export default __webpack_public_path__ + "static/media/Minus.f6a577ac.svg";